import API from "../../API";
import moment from "@/utils/moment";

const SET_ORDER = "SET_ORDER";
const SET_USER = "SET_USER";
const SET_ADDRESS = "SET_ADDRESS";
const SET_TO_BE = "SET_TO_BE";
const SET_PROFESSIONAL = "SET_PROFESSIONAL";
const SET_PROFESSIONALS_AVAILABLE = "SET_PROFESSIONALS_AVAILABLE";
const SET_EVENT = "SET_EVENT";
const SET_DAY = "SET_DAY";
const SET_STARTS_AT = "SET_STARTS_AT";
const SET_ENDS_AT = "SET_ENDS_AT";
const SET_ADDITIONAL_INFORMATIONS = "SET_ADDITIONAL_INFORMATIONS";
const SET_USE_MY_PRODUCTS = "SET_USE_MY_PRODUCTS";
const SET_PRICE = "SET_PRICE";
const SET_PRICE_CONFIRMED = "SET_PRICE_CONFIRMED";
const RESET_STATE = "RESET_STATE";
const SET_ORDER_TO_REBOOK = "SET_ORDER_TO_REBOOK";
const SET_REQUESTER = "SET_REQUESTER";

const getDefaultState = () => {
  return {
    order: null,
    user: null,
    address: null,
    to_be: null,
    professional: null,
    professionals_available: null,
    event: null,
    day: null,
    starts_at: null,
    ends_at: null,
    price: null,
    price_confirmed: false,
    additional_informations: "",
    use_my_products: false,
    orderToRebook: null,
    requester: null
  };
};

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    setOrder({ commit }, payload) {
      commit("SET_ORDER", payload);
    },

    setUser({ commit, dispatch }, payload) {
      commit("SET_USER", payload);
      dispatch("setAddress", null);
    },

    setAddress({ commit, dispatch }, payload) {
      commit("SET_ADDRESS", payload);
      dispatch("setToBe", "");
    },

    setToBe({ commit, dispatch, state }, type) {
      commit("SET_TO_BE", type);
      dispatch("setProfessionalsAvailable", null);

      if (state.orderToRebook && type === "schedule")
        dispatch("setScheduleOfOrderToRebook");
      else if (type === "schedule") dispatch("setDay", null);
    },

    setDay({ commit, dispatch }, payload) {
      commit("SET_DAY", payload);
      dispatch("setStartsAt", null);
    },

    setStartsAt({ commit, dispatch }, payload) {
      commit("SET_STARTS_AT", payload);
      dispatch("setEndsAt", null);
    },

    setEndsAt({ commit, dispatch, state }, payload) {
      commit("SET_ENDS_AT", payload);
      if (state.to_be === "schedule")
        dispatch("setProfessionalsAvailable", null);
      dispatch("getPrice");
    },

    setProfessionalsAvailable({ commit, dispatch, state }, payload) {
      commit("SET_PROFESSIONALS_AVAILABLE", payload);
      dispatch("setProfessional", null);
    },

    setProfessional({ commit, state, dispatch }, payload) {
      commit("SET_PROFESSIONAL", payload);
      if (state.to_be === "professional") dispatch("setEvent", null);
      else if (payload) dispatch("setEvent", payload.schedule_event);
    },

    setEvent({ commit, state, dispatch }, payload) {
      commit("SET_EVENT", payload);
      if (state.to_be === "professional" && payload)
        dispatch("setDay", payload.starts_at);
      else if (state.to_be === "professional") dispatch("setDay", null);
    },

    setPrice({ commit, dispatch }, payload) {
      commit("SET_PRICE", payload);
      dispatch("setPriceConfirmed", false);
    },

    setPriceConfirmed({ commit }, payload) {
      commit("SET_PRICE_CONFIRMED", payload);
    },

    setAdditionalInformations({ commit }, payload) {
      commit("SET_ADDITIONAL_INFORMATIONS", payload);
    },

    setUseMyProducts({ commit }, payload) {
      commit("SET_USE_MY_PRODUCTS", payload);
    },

    setOrderToRebook({ commit, dispatch }, payload) {
      commit("SET_ORDER_TO_REBOOK", payload);
      dispatch("setUser", payload.customer);
      dispatch("setAddress", payload.address);
      dispatch("setScheduleOfOrderToRebook");
    },

    setRequester({ commit, state }, type) {
      commit("SET_REQUESTER", state.orderToRebook[type]);
    },

    setScheduleOfOrderToRebook({ state, dispatch }) {
      dispatch(
        "setDay",
        moment(state.orderToRebook.schedule_event.starts_at).toDate()
      );
      dispatch(
        "setStartsAt",
        moment(state.orderToRebook.schedule_event.starts_at).format("HH:mm:ss")
      );
      dispatch(
        "setEndsAt",
        moment(state.orderToRebook.schedule_event.ends_at).format("HH:mm:ss")
      );
    },

    getPrice({ state, getters, dispatch }) {
      let total_price = null;

      if (state.address && getters.duration) {
        let pricing = state.address.district.pricing;
        let duration = getters.duration;

        let price = duration * pricing.price_per_hour + pricing.price;
        let fee = duration * pricing.fee_per_hour + pricing.fee;

        total_price = price + fee;
      }

      dispatch("setPrice", total_price);
    },

    resetState({ commit }) {
      commit("RESET_STATE");
    },

    async searchProfessionalsAvailable({ state, commit }) {
      try {
        let day = moment(state.day).format("Y-MM-DD ");
        let starts_at = day + state.starts_at;
        let ends_at = day + state.ends_at;

        let res = await API.Professionals.getAvailables({
          data: {
            attributes: {
              district_id: state.address.district.id,
              starts_at,
              ends_at
            }
          }
        });

        commit("SET_PROFESSIONALS_AVAILABLE", res);
      } catch (e) {
        throw e;
      }
    },

    async create({ state, dispatch }) {
      try {
        let day = moment(state.day).startOf("hour");
        let starts_at = day.hour(state.starts_at.substr(0, 2)).toISOString();
        let ends_at = day.hour(state.ends_at.substr(0, 2)).toISOString();

        let data_order = {
          data: {
            type: "orders",
            attributes: {
              starts_at,
              ends_at,
              description: state.additional_informations
            },
            relationships: {
              customer: {
                data: {
                  type: state.user.accountable.type,
                  id: state.user.accountable.id
                }
              },
              professional: {
                data: {
                  type: "professionals",
                  id: state.professional.id
                }
              },
              schedule_event: {
                data: {
                  type: "schedule_events",
                  id: state.event.id
                }
              },
              address: {
                data: {
                  type: "addresses",
                  id: state.address.id
                }
              }
            }
          }
        };

        let order = await API.Orders.create(data_order);
        dispatch("setOrder", order);
      } catch (e) {
        throw e;
      }
    },

    async rebookOrReschedule({ state }) {
      try {
        let day = moment(state.day).startOf("hour");
        let newStartsAt = day.hour(state.starts_at.substr(0, 2)).toISOString();
        let newEndsAt = day.hour(state.ends_at.substr(0, 2)).toISOString();

        let data = {
          requester: state.requester,
          order: state.orderToRebook,
          toProfessional: state.professional,
          toScheduleEvent: state.event,
          newStartsAt,
          newEndsAt
        };

        return state.orderToRebook.professional.id === state.professional.id
          ? await API.Orders.reschedule(data)
          : await API.Orders.rebook(data);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {
    [SET_ORDER](state, payload) {
      state.order = payload;
    },
    [SET_USER](state, payload) {
      state.user = payload;
    },
    [SET_ADDRESS](state, payload) {
      state.address = payload;
    },
    [SET_TO_BE](state, payload) {
      state.to_be = payload;
    },
    [SET_PROFESSIONAL](state, payload) {
      state.professional = payload;
    },
    [SET_PROFESSIONALS_AVAILABLE](state, payload) {
      state.professionals_available = payload;
    },
    [SET_EVENT](state, payload) {
      state.event = payload;
    },
    [SET_DAY](state, payload) {
      state.day = payload;
    },
    [SET_STARTS_AT](state, payload) {
      state.starts_at = payload;
    },
    [SET_ENDS_AT](state, payload) {
      state.ends_at = payload;
    },
    [SET_ADDITIONAL_INFORMATIONS](state, payload) {
      state.additional_informations = payload;
    },
    [SET_USE_MY_PRODUCTS](state, payload) {
      state.use_my_products = payload;
    },
    [SET_PRICE](state, payload) {
      state.price = payload;
    },
    [SET_PRICE_CONFIRMED](state, payload) {
      state.price_confirmed = payload;
    },
    [SET_ORDER_TO_REBOOK](state, payload) {
      state.orderToRebook = payload;
    },
    [SET_REQUESTER](state, payload) {
      state.requester = payload;
    },
    [RESET_STATE](state) {
      Object.assign(state, getDefaultState());
    }
  },

  getters: {
    disabledHours(state) {
      let res = [];

      for (var hour = 7; hour < 22; hour++) {
        let start = state.starts_at
          ? parseInt(state.starts_at.substr(0, 2))
          : state.starts_at;
        if (start && (start > hour || start + 8 < hour)) res.push(hour);
      }

      return res;
    },
    labelDuration(state) {
      return !state.starts_at
        ? "selecione a hora inicial"
        : !state.ends_at
        ? "selecione a hora final"
        : parseInt(state.starts_at.substr(0, 2)) +
          "hrs às " +
          parseInt(state.ends_at.substr(0, 2)) +
          "hrs";
    },
    duration(state) {
      let res = 0;

      if (state.starts_at && state.ends_at) {
        let start = parseInt(state.starts_at.substr(0, 2));
        let end = parseInt(state.ends_at.substr(0, 2));

        res = end - start;
      }

      return res;
    },
    canGoToCheckout(state) {
      return state.address &&
        state.professional &&
        state.day &&
        state.starts_at &&
        state.ends_at &&
        state.price &&
        state.additional_informations
        ? true
        : false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/newOrder.js